import * as React from "react";
import { styled } from "@lib/components";
import { Droppable } from "react-beautiful-dnd";

const Wrapper = styled("div")`
  padding-top: 5px; // needed to allow dropping onto empty list
  display: block;
  .list-item {
    padding: 6px 0;
  }

  &.is-edit-prices {
	padding-bottom: 100px;
  }
`;

interface MenuListProps {
	id: string;
	type: string;
	disabled?: boolean;
	mode?: "normal" | "reOrder" | "editPrices";
}

export class MenuList extends React.PureComponent<MenuListProps> {

	constructor(props: MenuListProps) {
		super(props);
	}

	render() {
		const { id, type, children, disabled, mode } = this.props;
		return (
			<Droppable droppableId={id} type={type} isDropDisabled={disabled}>
				{(provided) => (
					<Wrapper 
						ref={provided.innerRef} {...provided.droppableProps}
						className={mode === "editPrices" ? "is-edit-prices" : ""}>
						{children}
						{provided.placeholder}
					</Wrapper>
				)}
			</Droppable>
		);
	}

}
